/* override */
import { prop } from 'ramda';
import { useCallback, useMemo } from 'react';
import { useUserSelector } from 'js/store/hooks';
import { useAppSelector } from '@core/js/store/hooks';
import { useComponentConfig } from 'js/hooks/component';

import { KAMBI_DEFAULT_LOCALE, KAMBI_DEFAULT_LOCALE_MAP } from 'js/components/main/Kambi/constants';

export const useKambiConfig = () => {
    const currencyCode = useUserSelector(prop('currencyCode'));
    const { DTAG_ENV } = useAppSelector(prop('dynamicTags'));
    const lang = useUserSelector(prop('lang'));
    const {
        market,
        oddsFormat,
        localeMap = KAMBI_DEFAULT_LOCALE_MAP,
        defaultLocale = KAMBI_DEFAULT_LOCALE
    } = useComponentConfig();

    const getLocale = useCallback(() => localeMap.find((item) => item.portal === lang)?.kambi || defaultLocale, [
        lang,
        localeMap,
        defaultLocale
    ]);

    return useMemo(() => {
        return {
            loginUrl: 'notification',
            currency: currencyCode,
            market,
            locale: getLocale(),
            streamingAllowedForPlayer: true,
            ...DTAG_ENV === 'stg' ? { enableBetGeniusTestPlayer: true } : {},
            ...oddsFormat ? { oddsFormat } : {}
        };
    }, [
        market,
        currencyCode,
        oddsFormat,
        getLocale,
        DTAG_ENV
    ]);
};
